// export const API_BASE = process.env.REACT_APP_API_URL;
// export const API_BASE = "http://localhost:8080";
export const API_BASE = 'https://bf-voice-assistance-be-962051462519.asia-east1.run.app';